import { useEffect, useRef } from 'react';
import { useToast } from './use-toast';

const useErrorToast = (errors) => {
  const { toast } = useToast();
  const displayedErrors = useRef(new Set());

  useEffect(() => {
    errors.forEach((error) => {
      if (error && !displayedErrors.current.has(error.message)) {
        toast({
          variant: "destructive",
          title: "Error",
          description: error.message || "Something went wrong. Please try again!",
        });
        displayedErrors.current.add(error.message);
      }
    });
  }, [errors, toast]);
};

export default useErrorToast;
